<template>
  <div class="vasion-white-background vasion-calc-height">
    <VasionSchedulersPage title="Scheduled Database Lookups" />
  </div>
</template>

<script>
export default {
  name: 'AutomationEngineDatabaseLookups',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
